import { Component, computed, inject } from '@angular/core';

import { ModalService, ModalType, ProgramTilesComponent } from '@program-suite/ui';
import { Router } from '@angular/router';
import { LookupStore, ProgramTile } from '@program-suite/data-common';
import { SelectWholesalerModalComponent } from '../select-wholesaler-modal/select-wholesaler-modal.component';

@Component({
  selector: 'lib-start-quote',
  imports: [ProgramTilesComponent],
  templateUrl: './start-quote.component.html',
  styleUrl: './start-quote.component.scss',
})
export class StartQuoteComponent {
  lookupStore = inject(LookupStore);
  tenants = computed(() => this.lookupStore.tenants());

  // Program ids (ProgramLibrary.ProgramEnum): RCIP = 1, LIO = 2. Used to scope the wholesaler list.
  private readonly RCIP_PROGRAM_ID = 1;
  private readonly LIO_PROGRAM_ID = 2;

  constructor(
    private router: Router,
    private modalService: ModalService,
  ) {}

  async handleTileSelect(tile: ProgramTile) {
    // Route based on the tile's routingUrl so different programs open their own wizard.
    // LIO uses the dedicated 2-step LIO wizard; everything else falls back to the RCIP wizard.
    const isLio = tile.routingUrl?.toLowerCase().includes('lio') ?? false;
    const targetRoute = isLio ? 'lio-quote/new' : 'quote/new';
    const programId = isLio ? this.LIO_PROGRAM_ID : this.RCIP_PROGRAM_ID;

    // Only wholesalers (tenants) with access to the selected program can be chosen. Load the
    // program-scoped list before opening the picker so it reflects the tile just selected.
    await this.lookupStore.loadLookup('tenants', undefined, programId);

    const modalOptions = {
      modalType: ModalType.Medium,
      data: {
        tenants: this.tenants()
      }
    };

    this.modalService.open(SelectWholesalerModalComponent, modalOptions, (tenantId) => {
      if (tenantId) {
        this.router.navigate([targetRoute], { queryParams: {tenantId} });
        return;
      }
    });
  }
}
